export enum Page {
  Home = '/home',
  Unavailable = '/unavailable',
  Login = '/login',
  Unauthorized = '/unauthorized',
  BankHolidays = '/bankHolidays',
  BankHolidayDates = '/bankHolidayDates',
  BlackPoints = '/blackpoints',
  Duties = '/duties',
  DutyAssignment = '/dutyAssignment',
  CalendarComparisonPage = '/calendarComparison',
  Error = '/error',
  Exchanges = '/exchanges',
  Planner = '/planner',
  Pharmacies = '/pharmacies',
  Transfers = '/transfers',
  PharmacyPage = '/pharmacy',
  Groups = "/groups",
  Secretariats = '/secretariats',
  Diagnostic = '/diagnostic',
  SecretariatPage = '/secretariat',
  SecretariatDashboard = '/secretariatDashboard',
  Users = '/users',
  UserPage = '/user',
  Zones = '/zones',
  GroupPage = '/group',
}
